<div (click)="onClick($event)">
  <span ngfSelect accept=".xlsx" [maxSize]="maxFileSize" [(lastInvalids)]="lastInvalids" (fileChange)="onFileChange($event)"
    #selector>
    <ng-content></ng-content>
  </span>
</div>